var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBirthdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 4.80005H20.63C20.8334 4.80264 21.0278 4.8846 21.1716 5.02844C21.3155 5.17229 21.3974 5.36664 21.4 5.57005V19.73C21.3974 19.9335 21.3155 20.1278 21.1716 20.2717C21.0278 20.4155 20.8334 20.4975 20.63 20.5H3.77C3.56659 20.4975 3.37224 20.4155 3.22839 20.2717C3.08455 20.1278 3.00259 19.9335 3 19.73V5.57005C3.00259 5.36664 3.08455 5.17229 3.22839 5.02844C3.37224 4.8846 3.56659 4.80264 3.77 4.80005H6.1",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.69995H21.4",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.80005H13.8",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30029 3V6.6",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1001 3V6.6",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9001 15.4H11.5001V13.6C11.5048 13.522 11.538 13.4485 11.5932 13.3932C11.6485 13.3379 11.7221 13.3048 11.8001 13.3H12.6001C12.6781 13.3048 12.7517 13.3379 12.807 13.3932C12.8622 13.4485 12.8954 13.522 12.9001 13.6V15.4H14.5001C14.8433 15.4052 15.1709 15.5438 15.4136 15.7865C15.6563 16.0292 15.7949 16.3569 15.8001 16.7V18H16.5001C16.6062 18 16.7079 18.0422 16.7829 18.1172C16.858 18.1922 16.9001 18.294 16.9001 18.4C16.9001 18.5061 16.858 18.6079 16.7829 18.6829C16.7079 18.7579 16.6062 18.8 16.5001 18.8H8.0001C7.89401 18.8 7.79227 18.7579 7.71725 18.6829C7.64224 18.6079 7.6001 18.5061 7.6001 18.4C7.6001 18.294 7.64224 18.1922 7.71725 18.1172C7.79227 18.0422 7.89401 18 8.0001 18H8.7001V16.7C8.68304 16.5336 8.70158 16.3655 8.75447 16.2067C8.80736 16.048 8.8934 15.9023 9.00688 15.7794C9.12036 15.6565 9.25869 15.559 9.41269 15.4936C9.56669 15.4282 9.73283 15.3963 9.9001 15.4ZM12.2001 11.3C12.3001 11.9 12.8001 12.2 12.8001 12.5C12.8118 12.5816 12.8044 12.6647 12.7784 12.7428C12.7523 12.821 12.7085 12.892 12.6503 12.9502C12.592 13.0084 12.521 13.0523 12.4429 13.0783C12.3647 13.1043 12.2816 13.1118 12.2001 13.1C12.1206 13.1028 12.0413 13.0892 11.9672 13.0601C11.8932 13.0309 11.8259 12.9868 11.7696 12.9305C11.7133 12.8742 11.6692 12.807 11.6401 12.7329C11.6109 12.6589 11.5973 12.5796 11.6001 12.5C11.6001 12.2 12.1001 11.9 12.2001 11.3Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBirthdate);
export default __webpack_public_path__ + "static/media/ic_birthdate.47076847136c13ef1c946dfafdf3b71a.svg";
export { ForwardRef as ReactComponent };